import _ from "lodash";
var codeAllDict = {
    "500000": {
        name: "首页",
        id: 1
    },
    "900000": {
        name: "接单管理"
    },
    "9001": {
        name: "订货单",
        id: 25
    },
    "9002": {
        name: "入库单",
        id: 26
    },
    "9003": {
        name: "退货单",
        id: 27
    },
    "9004": {
        name: "退货入库",
        id: 359
    },
    "1000000": {
        name: "送货管理"
    },
    "10001": {
        name: "送货单",
        id: 43
    },
    "10002": {
        name: "委托送货单",
        id: 389
    },
    "12008": {
        name: "账户余额管理",
        id: 412
    },
    "12009": {
        name: "充值管理",
        id: 413
    },
    "6010": {
        name: "岗位权限管理",
        id: 444
    },
    "1300000": {
        name: "价格管理"
    },
    "13001": {
        name: "报价",
        id: 80
    },
    "13002": {
        name: "定价",
        id: 81
    },
    "1200000": {
        name: "财务中心"
    },
    '12010': {
        name: '线上支付确认',
        id: 430
    },
    "12001": {
        name: "客户对账单",
        id: 68
    },
    "12002": {
        name: "客户付款单",
        id: 76
    },
    "12003": {
        name: "供应商对账单",
        id: 306
    },
    "12004": {
        name: "供应商付款单",
        id: 307
    },
    "12005": {
        name: "支付凭证",
        id: 370
    },
    "12006": {
        name: "支付凭证",
        id: 376
    },
    "12007": {
        name: "支付凭证",
        id: 382
    },
    "800000": {
        name: "货品管理"
    },
    "8001": {
        name: "货品档案",
        id: 17
    },
    "6006": {
        name: "供应商档案",
        id: 123
    },
    "1100000": {
        name: "客户管理"
    },
    "11001": {
        name: "合作客户",
        id: 48
    },
    "11002": {
        name: "客户分组",
        id: 57
    },
    "600000": {
        name: "企业管理",
        id: 5
    },
    "6001": {
        name: "企业信息",
        id: 5
    },
    "6009": {
        name: "机构管理",
        id: 261
    },
    "6002": {
        name: "证照管理",
        id: 6
    },
    "6003": {
        name: "用户管理",
        id: 7
    },
    "1400000": {
        name: "消息管理",
        id: 89,
        noAuth: true
    },
    "8002": {
        name: "货品类别",
        id: 94
    },
    "6007": {
        name: "销售价格",
        id: 192
    },
    "16001": {
        name: "打印设置",
        id: 112
    },
    "18001": {
        name: "分拣任务",
        id: 125
    },
    "210001": {
        name: "库存查询",
        id: 133
    },
    "210002": {
        name: "出入库明细",
        id: 134
    },
    "210003": {
        name: "出入库汇总",
        id: 135
    },
    "210006": {
        name: "采购明细",
        id: 272
    },
    "210007": {
        name: "采购汇总",
        id: 273
    },
    "210008": {
        name: "经营报表",
        id: 386
    },
    "210009": {
        name: "损耗分析",
        id: 407,
    },
    "210010": {
        name: "采购价格分析",
        id: 409
    },
    "210011": {
        name: "销售价格分析",
        id: 410
    },
    "6004": {
        name: "配送中心档案",
        id: 121,
    },
    '210013': {
        name: '业绩汇总',
        id: 414
    },
    '210014': {
        name: '业绩明细',
        id: 415
    },
    "210012": {
        name: '客户库存查询',
        id: 411
    },
    "6005": {
        name: "采购价格",
        id: 122
    },
    "1900000": {
        name: "采购"
    },
    "190002": {
        name: "采购计划",
        id: 269,
    },
    "190003": {
        name: "采购订货",
        id: 270,
    },
    "190001": {
        name: "采购入库",
        id: 136,
        noAuth: true
    },
    "190004": {
        name: "采购退货",
        id: 271,
    },
    "2000000": {
        name: "仓储"
    },
    "200001": {
        name: "调拨",
        id: 128
    },
    "200002": {
        name: "盘点",
        id: 129
    },
    "200003": {
        name: "损溢",
        id: 130
    },
    "200005": {
        name: "预警规则",
        id: 340
    },
    "310001": {
        name: "店铺管理",
        id: 216
    },
    "310002": {
        name: "售后管理",
        id: 217
    },
    "310003": {
        name: "新需求",
        id: 218
    },
    "310004": {
        name: "营销活动",
        id: 402
    },
    '310005': {
        name: '营销海报',
        id: 438
    },
    '16006': {
        name: '操作记录',
        id: 452
    },
    '5008': {
        name: "导出结果下载",
        id: 403,
        noAuth: true
    },
    '12011': {
        name: '发票管理',
        id: 470
    }
};
var codeAllDictMap = {
    storeInit: {
        code: "200004",
        name: "库存初始化",
        id: 131
    },
    salesSummaryReport: {
        code: "210005",
        name: "销售汇总报表",
        id: 228
    },
    salesDetail: {
        code: "210004",
        name: "销售明细",
        id: 189
    },
    thirdPartySystem: {
        code: "6008",
        name: "销售明细",
        id: 208
    },
    systemSettings: {
        code: "16002",
        name: "系统设置",
        id: 219
    },
    thirdPartyPayment: {
        code: "16003",
        name: "第三方支付",
        id: 220
    },
    orderImportTemplate: {
        code: "16004",
        name: "订货导入模板",
        id: 248
    },
    sortingSettings: {
        code: "16005",
        name: "分拣设置",
        id: 316
    },
    serviceInterface: {
        code: "16007",
        name: "接口服务",
        id: 460
    }
};
for (var key in codeAllDictMap) {
    codeAllDict[codeAllDictMap[key].code] = {
        name: codeAllDictMap[key].name,
        id: codeAllDictMap[key].id
    };
}
var pick = function (key) { return function (value) { return value[key]; }; };
export var codeDict = _.mapValues(codeAllDict, pick('name'));
export var idDict = _.mapValues(codeAllDict, pick('id'));
export var nameDict = _.chain(codeAllDict).invertBy(pick('name')).mapValues(function (value) { return value[0]; }).value();
export var noAuthList = _.keys(_.pickBy(codeAllDict, function (value) { return value.noAuth; }));
export var codeDictMap = codeAllDictMap;
